import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { useDict } from '../../../contexts/LanguageContext';
import ROUTE_NAME from '../../../routes/RouteName';
import FaqContainer from './FaqContainer';

const TypesOfInvestmentNotes = () => {
    const dict = useDict();

    return (
        <FaqContainer
            navigationActive="typesofinvestmentnotes"
            prevLink={ROUTE_NAME.FAQ_INVEST_NOW}
            prevTitle={dict.investNowFaq}
            nextLink={ROUTE_NAME.FAQ_REPAYMENTS}
            nextTitle={dict.repayments}
        >
            <Card className="card--not-full-height">
                <CardBody className="documentation__card-body">
                    <div className="card__title">
                        <h3 className="bold-text" style={{ color: '#264391' }}>
                            {dict.financingPlatform}
                        </h3>
                    </div>
                    <div className="card__title">
                        <h4 className="bold-text" style={{ color: '#264391' }}>
                            {dict.typesOfInvestmentNotes}
                        </h4>
                    </div>
                    <p>
                        <strong>
                            {dict.investmentNoteTypesTitle1}
                        </strong>
                    </p>
                    <p>
                        {dict.investmentNoteTypesTitle1Text1}
                    </p>
                    <ul>
                        <li>{dict.investmentNoteTypesTitle1Text1List1}</li>
                        <li>{dict.investmentNoteTypesTitle1Text1List2}</li>
                    </ul>
                    <p>
                        <strong>
                            {dict.investmentNoteTypesTitle2}
                        </strong>
                    </p>
                    <p>
                        {dict.investmentNoteTypesTitle2Text1}
                    </p>
                    <p>
                        <strong>
                            {dict.investmentNoteTypesTitle3}
                        </strong>
                    </p>
                    <p>
                        {dict.investmentNoteTypesTitle3Text1}
                    </p>
                    <p>
                        {dict.investmentNoteTypesTitle3Text2}
                    </p>
                    <p>
                        {dict.investmentNoteTypesTitle3Text3}
                    </p>
                    <p>
                        <strong>
                            {dict.investmentNoteTypesTitle4}
                        </strong>
                    </p>
                    <p>
                        {dict.investmentNoteTypesTitle4Text1}
                    </p>
                    <ol>
                        <li>{dict.investmentNoteTypesTitle4Text1List1}</li>
                        <li>{dict.investmentNoteTypesTitle4Text1List2}</li>
                        <li>{dict.investmentNoteTypesTitle4Text1List3}</li>
                        <li>{dict.investmentNoteTypesTitle4Text1List4}</li>
                        <li>{dict.investmentNoteTypesTitle4Text1List5}</li>
                        <li>{dict.investmentNoteTypesTitle4Text1List6}</li>
                        <li>{dict.investmentNoteTypesTitle4Text1List7}</li>
                    </ol>
                    <p>
                        <strong>
                            {dict.investmentNoteTypesTitle5}
                        </strong>
                    </p>
                    <p>
                        {dict.investmentNoteTypesTitle5Text1}
                    </p>
                    <p>
                        {dict.investmentNoteTypesTitle5Text2}
                    </p>
                    <p>
                        <strong>
                            {dict.investmentNoteTypesTitle6}
                        </strong>
                    </p>
                    <p>
                        {dict.investmentNoteTypesTitle6Text1}
                    </p>
                    <ol>
                        <li>{dict.investmentNoteTypesTitle6Text1List1}</li>
                        <li>{dict.investmentNoteTypesTitle6Text1List2}</li>
                    </ol>
                    <p>
                        <strong>
                            {dict.investmentNoteTypesTitle7}
                        </strong>
                    </p>
                    <p>
                        {dict.investmentNoteTypesTitle7Text1}
                    </p>
                </CardBody>
            </Card>
        </FaqContainer>
    );
};

export default TypesOfInvestmentNotes;
